import type {
	CompanyAddress,
	FetchCompanyAddressResponse,
} from '@/modules/clients/types';

export const toCompanyAddress = (
	address: FetchCompanyAddressResponse
): CompanyAddress => ({
	id: address.id,
	name: address.name ?? undefined,
	street: address.street ?? '',
	complement: address.complement ?? undefined,
	city: address.city ?? '',
	zip: address.zip ?? '',
	countryCode: address.countryCode ?? undefined,
	inseeCode: address.inseeCode,
	location:
		address.latitude && address.longitude
			? [address.longitude, address.latitude]
			: undefined,
});
